import React, {Component} from 'react'

import {Navbar} from 'react-bootstrap'
import './Layout/Header.css'
import NavigationLinks from '../NavigationLinks/NavigationLinks'
import MobileNavigation from '../NavigationLinks/MobileNavigation'
import {Link} from 'react-router'

class Header extends Component {
  render () {
    const location = this.context.router.location.pathname
    return (
      <div id="mainheader" className={(location === '/') ? 'index-header' : 'other-header'}>
        <Navbar>
          <Navbar.Header>
            {(location !== '/') && <Navbar.Brand>
              <Link to={'/'}>
                <span className="retina sprite1 tinylogo" />
              </Link>
            </Navbar.Brand>}
            <Navbar.Toggle />
          </Navbar.Header>
          <Navbar.Collapse>
            <NavigationLinks />
          </Navbar.Collapse>

          <MobileNavigation />
        </Navbar>
      </div>
    )
  }
}

Header.contextTypes = {
  router: React.PropTypes.object
}

export default Header



// WEBPACK FOOTER //
// ./src/components/Common/Header/Header.js